// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { SectionContainer, SectionContainerProps, useSession }
from "../../../lib"
import { useAccount } from "../context"


const ConsoleSectionContainer: React.FC<SectionContainerProps> = ({children, booting, ...props}) => {
  const {accounts, activeAccount, permissions} = useAccount()
  const session = useSession()
  const isBooting = !session.ready
    || accounts === null
    || (!!activeAccount && permissions === null)
    || booting
  return (
    <SectionContainer booting={isBooting}  {...props}>{children}</SectionContainer>
  )
}


export { ConsoleSectionContainer }